import { render, staticRenderFns } from "./Occurrences.vue?vue&type=template&id=08bf966d&scoped=true"
import script from "./Occurrences.vue?vue&type=script&lang=ts"
export * from "./Occurrences.vue?vue&type=script&lang=ts"
import style0 from "./Occurrences.vue?vue&type=style&index=0&id=08bf966d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf966d",
  null
  
)

export default component.exports